/* DON'T EDIT THIS FILE: edit original and run build again */ export const laAnonimaFullLabel =
  "S.A. IMPORTADORA Y EXPORTADORA DE LA PATAGONIA";
